/* eslint-disable */
import { Component } from 'react';
import { Container } from 'reactstrap';
import { Utils, API, Http, Trans } from 'Helpers';
import { MessageBox, MobHeader } from 'Components';
import parse from 'html-react-parser';
import { ReduxHOC } from 'HOC';


var ourImage = new Image();
ourImage.Class = 'irimg';
// const image = document.querySelector('img');
// const parentDiv = image.parentElement.

class StaticPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      SelectedLeague: Utils.getMultiLeg(),
      PageData: [],
      posting: true,
      contestData : JSON.parse(localStorage.getItem('contestData')) || {}
    }
  }


  componentDidMount() {
    this.isComponentMounted = true;
    this.getDetails();
  }

  componentWillUnmount() {
    this.isComponentMounted = false;
  }

  getDetails = () => {
    const { page_id } = this.props
    const { SelectedLeague } = this.state
    Http.post(API.GET_PAGE_DETAIL, {
      "page_id": page_id,
      "sports_id": SelectedLeague && SelectedLeague.sports_id || '0'
    }).then(res => {
      if (!this.isComponentMounted) return;

      this.setState({
        PageData: res.data,
        posting: false
      })

    })
  }
  render() {
    const { name, page_id } = this.props
    const { PageData, posting, contestData } = this.state
    const MessageBoxProps = {
      Title: name,
      Subtitle: ''
    }

    let  MobHeaderProps={
      // titleContest:contestData,
      backTitleAction:"",
      drawerMenu:true,
      backHandle:true,
      title: name,
      centerTitle: name,
      backTo:'/'
  }
    return (
      <>
        {page_id!=2 && <MobHeader {...MobHeaderProps}/>}
        <Container className={`small-container cont-spc-mob ${page_id==2?'how-to-play-container':''}`}>
          {
            posting ?
              <Utils.Spinner primary />
              :
              <>
                {
                  _.isEmpty(PageData) ?
                    <MessageBox {...MessageBoxProps} />
                    :
                    <>
                      {page_id !=2 && <div className="title-stp">
                        <Trans>{PageData.page_title || name}</Trans>
                      </div>}
                      <div className={`static-page-body ${page_id==2?'how-to-play':''}`}>

                        {page_id ==2 ? 
                         <iframe
                            src="/learn/index.html"
                            style={{ width: "100%", height: "100vh", border: "none" }}
                          />
                        :parse(PageData.page_content)
                        }
                      </div>
                    </>
                }
              </>
          }
        </Container>
      </>
    );
  }
}

export default ReduxHOC(StaticPage);
